import { TipoMapaTalhoes } from "features/maps/typings";

import BaseMap from "../base-map";
import SatelliteLayers from "components/Satellite/Layers";
import { TalhaoDetailContextProvider } from "features/maps/talhao/TalhaoDetailContext";
import TalhaoModal from "../mapa-geral/components/TalhaoModal";
import { getDefaultIndex } from "./utils";
import { useLoading } from "features/global-loading";
import { useState } from "react";
import { useMapaConcentracaoColheita } from "features/maps/hooks/useMapaConcentracaoColheita";
import { useFilters } from "features/filters/store";
import { useMapStore } from "features/maps/store/useMapStore";

function MapaConcentracaoColheita() {
  const [map, setMap] = useState<google.maps.Map | undefined>();
  const {
    filters: { unidade, tipoMapa },
  } = useFilters();

  const { center, updateTalhao, talhao } = useMapStore();

  const { data, isLoading } = useMapaConcentracaoColheita();

  useLoading(isLoading);

  return (
    <>
      <BaseMap
        onLoadMap={(map: google.maps.Map | undefined) => setMap(map)}
        onClickItem={(_, feature) => {
          if (feature.id) {
            updateTalhao(feature);
          }
        }}
        points={data}
        center={center ? center : unidade?.pontoCentral}
        isLoading={isLoading}
      >
        {tipoMapa === TipoMapaTalhoes.Satelite ? (
          <SatelliteLayers map={map} />
        ) : null}
      </BaseMap>

      {talhao ? (
        <TalhaoDetailContextProvider defaultIndex={getDefaultIndex(tipoMapa)}>
          <TalhaoModal
            talhao={talhao}
            onClose={() => updateTalhao(undefined)}
          />
        </TalhaoDetailContextProvider>
      ) : null}
    </>
  );
}

export default MapaConcentracaoColheita;
